/**
 * @generated SignedSource<<d23939bc90a071458bffb8198a3a24a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ArchiveFlowInput = {
  clientMutationId?: string | null | undefined;
  flowId: UUID;
};
export type GroupTemplateOptionsMutation$variables = {
  input: ArchiveFlowInput;
};
export type GroupTemplateOptionsMutation$data = {
  readonly archiveFlow: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type GroupTemplateOptionsMutation = {
  response: GroupTemplateOptionsMutation$data;
  variables: GroupTemplateOptionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchiveFlowPayload",
    "kind": "LinkedField",
    "name": "archiveFlow",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GroupTemplateOptionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GroupTemplateOptionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3f838d69da3cd629700308653b81a5b3",
    "id": null,
    "metadata": {},
    "name": "GroupTemplateOptionsMutation",
    "operationKind": "mutation",
    "text": "mutation GroupTemplateOptionsMutation(\n  $input: ArchiveFlowInput!\n) {\n  archiveFlow(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "87c05902bee1463f59f43be60ae7ec92";

export default node;
